// Sprint 8.J — wspólna definicja grup admin menu.
// Uzywana przez Sidebar (rozwijalne kategorie) i AdminDashboard (kafelki narzedzi).
import {
  LayoutDashboard, Shield, Wallet, ShoppingBag, Star, Send, Globe, Activity, BarChart3,
  FileText as FileTextIcon, Award, Search, AlertTriangle, Brain, Sparkles, Power, Link2,
  Plug, BookOpen, Beaker, Code, Repeat, Layers, Bot, Zap, MousePointerClick, Twitter,
  TrendingUp, Tag, Share2, Rss, ListTodo, MessageSquare, MessageCircle, Smartphone,
  CheckSquare, ShoppingCart, Puzzle, CreditCard, Mail, ImageIcon, Settings,
} from "lucide-react";

export const ADMIN_GROUPS = [
  {
    key: "main",
    label: "Główne",
    icon: LayoutDashboard,
    color: "blue",
    items: [
      { path: "/", icon: LayoutDashboard, label: "Dashboard",
        desc: "Statystyki portfela portali i szybki podgląd" },
      { path: "/admin", icon: Shield, label: "Panel Admin",
        desc: "Zarządzanie użytkownikami i konfiguracja globalna" },
      { path: "/admin/zorki", icon: Wallet, label: "Zorki Admin",
        desc: "System rankingowy — konfiguracja i wypłaty" },
      { path: "/shop", icon: ShoppingBag, label: "Sklep",
        desc: "Publiczny katalog portali sprzedażowych" },
      { path: "/zorki", icon: Star, label: "Moje Zorki",
        desc: "Twój wallet z zoromi (kredyty)" },
      { path: "/messages", icon: Send, label: "Wiadomości",
        desc: "Wewnętrzne wiadomości i negocjacje" },
    ],
  },
  {
    key: "portals",
    label: "Portale i Domeny",
    icon: Globe,
    color: "emerald",
    items: [
      { path: "/publisher", icon: Globe, label: "Panel Wydawcy",
        desc: "Podgląd jak widzi to wydawca (dashboard po stronie serwisu)" },
      { path: "/sites", icon: Globe, label: "Portale",
        desc: "CRUD portali, integracje API, ustawienia SEO per portal" },
      { path: "/admin/domain-hunter", icon: Globe, label: "Domain Hunter",
        desc: "AI codziennie sprawdza wygasające PL domeny na aftermarket, analizuje Wayback + generuje pomysł biznesowy" },
      { path: "/aftermarket-domains", icon: Globe, label: "Domeny (Aftermarket)",
        desc: "Sprawdzanie i przedłużanie domen z json.aftermarket.pl" },
      { path: "/admin/batch-deploy", icon: Zap, label: "Batch Deploy 🚀",
        desc: "Wpisz liste domen → agent automatycznie: DNS + SSL + deploy + AI konfiguracja + auto_publish + QA (ETA 15 min/domena)" },
      { path: "/admin/hunted-portfolio", icon: Globe, label: "Hunted Portfolio 🎯",
        desc: "Deploy 1 domeny z formularza + monitoring statusu (VPS #2)" },
      { path: "/admin/hunted-tips", icon: Globe, label: "Zgłoszenia tematów 💡",
        desc: "Tematy zgłoszone przez czytelników do publikacji na hunted portalach" },
      { path: "/admin/hunted-errors", icon: AlertTriangle, label: "Błędy hunted 🐛",
        desc: "Log błędów z hunted portali (frontend + backend + PSI)" },
    ],
  },
  {
    key: "seo",
    label: "SEO i Analityka",
    icon: BarChart3,
    color: "amber",
    items: [
      { path: "/admin/live", icon: Activity, label: "🔴 Live Dashboard",
        desc: "Live monitoring publikacji, alertów i aktywnych portali w czasie rzeczywistym" },
      { path: "/admin/seo-dashboard", icon: BarChart3, label: "SEO Dashboard",
        desc: "Google Search Console + Analytics: kliknięcia, pozycje, CTR na 209 portali" },
      { path: "/admin/daily-report", icon: FileTextIcon, label: "Daily Report",
        desc: "Codzienny raport wydajności — TOP wzrosty i spadki, alerty jakości" },
      { path: "/admin/rank-tracker", icon: Award, label: "Rank Tracker",
        desc: "Pozycje słów kluczowych w Google — DDG/CSE/SerpAPI, wykres 30 dni" },
      { path: "/admin/keyword-research", icon: Search, label: "Keyword Research",
        desc: "Trends, PAA, Autocomplete — nowe tematy do publikacji" },
      { path: "/admin/cannibalization", icon: AlertTriangle, label: "Cannibalization",
        desc: "Wykrywanie kanibalizacji: 2 posty na tę samą frazę → bulk noindex loserów" },
      { path: "/admin/insights", icon: Brain, label: "Insights ++",
        desc: "Schema audit, Internal Linking Health, Content Gap Analyzer" },
      { path: "/admin/smart-publishing", icon: Sparkles, label: "Smart Publishing",
        desc: "A/B Title Testing + Performance Predictor + Site Health Monitor" },
      { path: "/admin/noindex", icon: AlertTriangle, label: "Bulk Noindex",
        desc: "Masowe oznaczanie niskiej jakości postów (score ≤ 25) jako noindex" },
      { path: "/admin/reactivator", icon: Power, label: "Reaktywator 💰",
        desc: "Włączanie auto_publish dla zdrowych stand-by portali (passive income)" },
      { path: "/admin/money", icon: Wallet, label: "Money Map 💵",
        desc: "Mapa dochodowa 8735 money postów — TOP5 finance dominuje portfolio" },
      { path: "/admin/cross-linking", icon: Link2, label: "Cross-Portal 🔗",
        desc: "Mapowanie portali ↔ kategorie dla auto-CTA między serwisami" },
      { path: "/admin/api-integrations", icon: Plug, label: "API Integracje",
        desc: "Publisher API v2 — konfiguracja endpointów dla zewnętrznych klientów" },
      { path: "/api-docs", icon: BookOpen, label: "Dokumentacja API",
        desc: "Publiczna dokumentacja Emergent Blog API v1" },
      { path: "/admin/zorki-public-api", icon: Star, label: "Zorki Public API ⭐",
        desc: "Klucz + dokumentacja publicznego API zwracajacego portale z flaga zorki_enabled" },
      { path: "/admin/gambling-moderation", icon: AlertTriangle, label: "Gambling Moderacja",
        desc: "Skanuje nasze gambling posty, weryfikuje linki reklamodawcy, generuje edukacyjną wersję dla dead/blocked" },
      { path: "/wydawcy-testy", icon: Beaker, label: "Sandbox wydawcy",
        desc: "16 testów integracji dla nowych wydawców" },
    ],
  },
  {
    key: "content",
    label: "Treści AI",
    icon: Sparkles,
    color: "purple",
    items: [
      { path: "/generator", icon: Sparkles, label: "Content Generator",
        desc: "Generator artykułów AI z tematu (Grok/GPT/Gemini)" },
      { path: "/html-generator", icon: Code, label: "HTML Generator",
        desc: "Konwersja treści na HTML z Schema.org + FAQ" },
      { path: "/rewrite", icon: Repeat, label: "Rewrite Article",
        desc: "Przepisywanie starych artykułów pod aktualne trendy SEO" },
      { path: "/mass-generate", icon: Layers, label: "Mass Generate",
        desc: "Bulk generation kilkudziesięciu artykułów naraz z queue" },
      { path: "/auto-publish", icon: Bot, label: "Auto-Publish",
        desc: "Konfiguracja agentów automatycznych publikacji per portal" },
      { path: "/keyword-research", icon: Search, label: "Keyword Research",
        desc: "Sugestie fraz + volume + trudność" },
      { path: "/breaking-news", icon: Zap, label: "Breaking News",
        desc: "Reagowanie na trending topics — auto-artykuły z newsów" },
      { path: "/performance", icon: BarChart3, label: "Efektywność stron",
        desc: "Google Search Console + Analytics per URL — kliknięcia, pozycje" },
      { path: "/internal-linking", icon: Link2, label: "Internal Linking",
        desc: "Auto-linkowanie wewnętrzne między artykułami tego samego portalu" },
      { path: "/clickbait", icon: MousePointerClick, label: "Clickbait Detector",
        desc: "Analiza tytułów pod CTR — sugestie ulepszenia" },
      { path: "/twitter-analysis", icon: Twitter, label: "Twitter Analysis",
        desc: "Import twittów jako źródło pending_posts" },
      { path: "/seo-agent", icon: Brain, label: "SEO Agent",
        desc: "Autonomiczny agent SEO — cadence + topical authority" },
      { path: "/trends", icon: TrendingUp, label: "Trending Topics",
        desc: "Google Trends + PAA — świeże tematy do publikacji" },
    ],
  },
  {
    key: "marketing",
    label: "Marketing i Automatyzacja",
    icon: Rss,
    color: "rose",
    items: [
      { path: "/affiliates", icon: Tag, label: "Affiliates",
        desc: "Produkty afiliacyjne + rankingi" },
      { path: "/social", icon: Share2, label: "Social Media",
        desc: "Auto-postowanie na Facebook/Twitter po publikacji" },
      { path: "/rss", icon: Rss, label: "RSS Feeds",
        desc: "47 RSS-ów newsowych — 121 newsów/24h auto-publikacji" },
      { path: "/queue", icon: ListTodo, label: "Kolejka publikacji",
        desc: "Pending_posts oczekujące na zatwierdzenie (RSS/Twitter/Email)" },
    ],
  },
  {
    key: "mail",
    label: "Poczta i Komunikacja",
    icon: Mail,
    color: "sky",
    items: [
      { path: "/mail", icon: Mail, label: "Skrzynka",
        desc: "Inbox biuro@zens.pl, sortowanie AI, foldery, wysyłka" },
      { path: "/mail-drafts", icon: Mail, label: "Drafty AI ✨",
        desc: "Auto-drafty AI dla leadów — bulk send/reject, edycja inline" },
      { path: "/comments", icon: MessageSquare, label: "Komentarze",
        desc: "AI persona discussions pod artykułami" },
      { path: "/forums", icon: MessageCircle, label: "Fora",
        desc: "Zarządzanie forumami klientów" },
      { path: "/reports", icon: Smartphone, label: "Zgłoszenia",
        desc: "Bug reports + feedback z widgetu użytkowników" },
    ],
  },
  {
    key: "system",
    label: "System",
    icon: Settings,
    color: "slate",
    items: [
      { path: "/monitor", icon: Activity, label: "AI Monitor",
        desc: "Alerty systemowe, błędy publikacji, awarie portali" },
      { path: "/tasks", icon: CheckSquare, label: "Zadania",
        desc: "Task manager - twoje TODO w projekcie" },
      { path: "/woo-products", icon: ShoppingCart, label: "WooCommerce",
        desc: "Produkty WooCommerce z portali sprzedażowych" },
      { path: "/connectors", icon: Plug, label: "Konektory",
        desc: "Integracje z zewnętrznymi platformami" },
      { path: "/extensions", icon: Puzzle, label: "Rozszerzenia",
        desc: "Wtyczki i moduły dodatkowe" },
      { path: "/subscription", icon: CreditCard, label: "Subskrypcje",
        desc: "Płatności i rozliczenia klientów" },
      { path: "/media", icon: ImageIcon, label: "Biblioteka mediów",
        desc: "Upload obrazów, kategorie (zero, sex, etc.), używane przez auto-publishera" },
      { path: "/settings", icon: Settings, label: "Ustawienia",
        desc: "Konfiguracja globalna aplikacji" },
    ],
  },
];

// Znajdz do jakiej grupy nalezy dany path
export function findGroupForPath(pathname) {
  for (const g of ADMIN_GROUPS) {
    for (const it of g.items) {
      if (it.path === pathname) return g.key;
      // partial match dla podscierzek /admin/xxx
      if (pathname.startsWith(it.path + "/") && it.path !== "/") return g.key;
    }
  }
  return null;
}
